import { render, staticRenderFns } from "./PendingAppointments.vue?vue&type=template&id=269f8af6&"
import script from "./PendingAppointments.vue?vue&type=script&lang=ts&"
export * from "./PendingAppointments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports